export default __webpack_public_path__ + "static/media/airbnb.3940fac8.jpg";